/**
 * Просьба открыть внешнюю ссылку во встроенном браузере.
 *
 * ── Почему событие, а не вызов ──────────────────────────────────────────────
 *
 * Ссылку нажимают глубоко внутри переписки, а открывать её должен раздел
 * «Браузер» — соседняя ветка дерева. Протаскивать обработчик от корня через
 * список чатов, ленту и разметку текста значило бы добавить одинаковый проп
 * в шесть компонентов, ни один из которых про браузер ничего не знает.
 *
 * ── Почему не просто новая вкладка оболочки ─────────────────────────────────
 *
 * Нативная вкладка ложится ПОВЕРХ страницы в область, которую задал последний
 * показанный раздел. Открытая из Telegram, она легла бы поверх переписки, и
 * закрыть её было бы нечем: адресной строки и списка вкладок в Telegram нет.
 */

import { openExternal } from './desktop.js';

export const OPEN_EXTERNAL_URL = 'bucor:open-external-url';

/**
 * Открыть ссылку во встроенном браузере.
 *
 * Возврат к прямому открытию — не запасной путь на всякий случай, а рабочий
 * исход: раздел «Браузер» есть не у всех, доступ к нему выдаёт администратор.
 * Слушателя ловим по факту его ответа: событие отменяют через
 * preventDefault(), и это единственный способ узнать, взялся ли кто-то за
 * ссылку, — обычное CustomEvent ничего не возвращает.
 */
export function openInAppBrowser(url: string): void {
  const event = new CustomEvent(OPEN_EXTERNAL_URL, { detail: url, cancelable: true });
  const handled = !window.dispatchEvent(event);
  if (!handled) openExternal(url);
}
